import { useEffect, useState } from 'react';

import { getI18n } from 'react-i18next';
import { fetchApi } from 'utils/fetchApi';

import { useUserOrganization } from '~/features/organizations/hooks/useUserOrganization';


const LOOKER_AI_IMPACT_BY_LANGUAGE = {
  EN: 372,
  FR: 379,
  DE: 377,
  IT: 380,
  ES: 378,
  PT: 376,
};

let LOOKER_AI_IMPACT_REPORT_ID = LOOKER_AI_IMPACT_BY_LANGUAGE['EN'];


export type AiImpactState = {
  looker: {
    loading: boolean;
    url: string | null;
    error?: string;
  };
};
const initialState: AiImpactState = {
  looker: {
    loading: false,
    url: null,
  },
};

export function useAiImpact() {
  const { language } = getI18n();
  const [looker, setLooker] = useState<AiImpactState['looker']>(initialState.looker);
  const LANG_KEY = language.split('_')[0].toUpperCase();
  const { organizationData, isLoading, error } = useUserOrganization();

  if (LOOKER_AI_IMPACT_BY_LANGUAGE[LANG_KEY as keyof typeof LOOKER_AI_IMPACT_BY_LANGUAGE]) {
    LOOKER_AI_IMPACT_REPORT_ID = LOOKER_AI_IMPACT_BY_LANGUAGE[LANG_KEY as keyof typeof LOOKER_AI_IMPACT_BY_LANGUAGE];
  }

  useEffect(() => {
    let stale = false;
    async function fetchLookerURL(language: string) {
      setLooker({
        loading: true,
        url: null,
      });
      try {
        const result = await fetchApi(
          `/api/lookerDashboardUrlById?lang=${language}&id=${LOOKER_AI_IMPACT_REPORT_ID}`,
          {
            method: 'GET',
          },
        );
        const data = (await result.json()) as { url: string };
        if (!stale) {
          setLooker({
            loading: false,
            url: data.url,
          });
        }
      } catch (error) {
        console.error(`Failed to fetch Looker URL: ${error}`);
        if (!stale) {
          setLooker({
            loading: false,
            url: null,
            error: String(error),
          });
        }
      }
    }
    fetchLookerURL(language);

    return () => {
      stale = true;
    };
  }, [language]);

  return { org: organizationData, looker, isLoading, error };
}
